export default (function (section, scrollWrapper) {
  const events = section.querySelectorAll('.events');

  const setActiveEventItem = (index) => {
    const tags = section.querySelectorAll('.events__item__content__tag__text');
    
    events.forEach((event, i) => {
      if (i === index) {
        event.classList.add('events__item_active');
        tags[i].classList.add('events__item_active__tag')
        event.querySelectorAll('.events__item__cardItem').forEach((item) => {
          item.classList.add('events__item_active__cardItem')
        })
      } else {
        event.classList.remove('events__item_active');
        tags[i].classList.remove('events__item_active__tag')
        event.querySelectorAll('.events__item__cardItem').forEach((item) => {
          item.classList.remove('events__item_active__cardItem')
        })
      }
    });
  };

  const onScroll = (e) => {
    const event = section.querySelector('.sticky');
    const { top } = event.getBoundingClientRect();
    const item = section.querySelector('.events__item')
    if (Math.floor(top) <= item.offsetHeight) {
      for (let i = 0; i < events.length; i++) {
        let { top: yEvent } = events[i].getBoundingClientRect();
        if (yEvent > -item.offsetHeight * 2) {
          setActiveEventItem(i);
          break;
        }
      }
    }
  };

  scrollWrapper.addEventListener('scroll', onScroll);
});
